import { CountryCode } from '@dayetopia/library';
import { WindowLocation } from '@reach/router';
import { CartItems, CartItem, CurrencyObj, TFunction } from '@contracts';
import { verifyCouponOnBilling } from '@utils/useVerifyCoupon';

interface SharedCouponVerificationParams {
  coupon: string;
  cartItems: CartItems;
  country: CountryCode;
  currency: CurrencyObj;
  price: number;
  t: TFunction;
  orders?: any[];
  location?: WindowLocation;
}

interface CouponVerificationResult {
  success: boolean;
  error?: string;
  discountAmount?: number;
  couponObject?: any;
  freeGift?: CartItem;
}

export async function verifyCouponShared({
  coupon,
  cartItems,
  country,
  currency,
  price,
  t,
  orders = [],
  location
}: SharedCouponVerificationParams): Promise<CouponVerificationResult> {
  const verificationResult: CouponVerificationResult = { success: false };

  const setCouponError = (error: string) => {
    verificationResult.error = error;
  };

  const setCheckoutDiscountAmount = (amount: number) => {
    verificationResult.discountAmount = amount;
  };

  const setCouponObject = (couponObject: any) => {
    verificationResult.couponObject = couponObject;
    verificationResult.success = true;
  };

  const handleFreeGift = (freeGift: CartItem) => {
    verificationResult.freeGift = freeGift;
  };

  // Call the existing verification function
  try {
    await verifyCouponOnBilling(
      setCouponError,
      coupon,
      setCheckoutDiscountAmount,
      setCouponObject,
      cartItems,
      country,
      currency,
      price,
      t,
      handleFreeGift,
      orders,
      location
    );

    // If no error was set and we have a discount amount or coupon object, it's successful
    if (!verificationResult.error && (verificationResult.discountAmount || verificationResult.couponObject)) {
      verificationResult.success = true;
    }

    return verificationResult;
  } catch (error) {
    verificationResult.success = false;
    verificationResult.error = verificationResult.error || 'Coupon verification failed';
    return verificationResult;
  }
}
